<template>
  <keep-alive include="AdminList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Admin",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
